import React, { useState, useEffect } from 'react'
import AlertCookies from './AlertCookies'
import AlertNotification from './AlertNotification'
import localforage from 'localforage'

let dismissedAlertIds = []

const Alerts = ({
  region,
  alertsDismissible = [],
  alertsNonDismissible = [],
  cookieAlertText,
  cookieButtonText,
  pluginOptions: { DISABLE_COOKIE_BANNER, SLUG },
}) => {
  const cookieBannerId = `cookies-${region}-${SLUG}`
  const [visibleAlertId, setVisibleAlertId] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const cookieBannerDisabled = DISABLE_COOKIE_BANNER

  useEffect(() => {
    localforage.getItem('dismissed-alerts').then(result => {
      dismissedAlertIds = result || []
      showNextAlert()
      setIsLoading(false)
    })
  }, [])

  const dismissAlert = alertId => {
    dismissedAlertIds = Array.from(new Set([...dismissedAlertIds, alertId]))
    localforage.setItem('dismissed-alerts', dismissedAlertIds)
    showNextAlert()
  }

  const showNextAlert = () => {
    const cookieBannerDismissed = dismissedAlertIds.includes(cookieBannerId)
    if (!cookieBannerDismissed && !cookieBannerDisabled) {
      setVisibleAlertId(cookieBannerId)
      return
    }
    const nextAlertUid = alertsDismissible
      .filter(alert => !dismissedAlertIds.includes(alert.uid))
      .map(({ uid }) => uid)[0]
    setVisibleAlertId(nextAlertUid)
  }

  return (
    <>
      {alertsNonDismissible.map(alert => (
        <AlertNotification
          alert={alert}
          data-key={`alert-${alert.uid}`}
          hideCloseButton
          key={`alert-${alert.uid}`}
        />
      ))}
      {!isLoading && (
        <>
          {!cookieBannerDisabled && (
            <AlertCookies
              bannerText={cookieAlertText}
              buttonText={cookieButtonText}
              handleTermsAcceptClick={() => dismissAlert(cookieBannerId)}
              isActive={!dismissedAlertIds.includes(cookieBannerId)}
              index={-1}
            />
          )}
          {alertsDismissible.map((alert, index) => (
            <AlertNotification
              fixed
              alert={alert}
              data-key={`alert-${alert.uid}`}
              key={`alert-${alert.uid}`}
              dismissAlert={() => dismissAlert(alert.uid)}
              isActive={visibleAlertId === alert.uid}
              index={index}
            />
          ))}
        </>
      )}
    </>
  )
}

export default Alerts
